module.exports = __webpack_public_path__ + "static/media/md-map.3cb1e3cf.svg";